import type { ExportFeatureConfig } from '../types/export';

const DEFAULT_EXPORT_CONFIG: ExportFeatureConfig = {
  formats: ['csv'],
};

export function normalizeExportConfig(config: boolean | ExportFeatureConfig | undefined): ExportFeatureConfig | null {
  if (!config) {
    return null;
  }

  if (config === true) {
    return DEFAULT_EXPORT_CONFIG;
  }

  return {
    ...DEFAULT_EXPORT_CONFIG,
    ...config,
  };
}
